import { IS_LOADING, ERROR} from "../../constants";

export { IS_LOADING, ERROR }

export const SET_COMPANIES = "SET_COMPANIES"
export const SET_LOCAL_AGENCY = "SET_LOCAL_AGENCY"
